import { Client } from '../../Client';
import { MediaObject, MediaTemporaryUrlsResponse } from '../MediaClient';
import { AxiosRequestConfig } from 'axios';

class MediaLinkClient extends Client {
  readonly route = {
    mediaByToken: `${this.http.baseUrl}/media-links/{token}`,
    temporaryUrlsByToken: `${this.http.baseUrl}/media-links/{token}/temporary-urls`,
  };

  mediaByToken = (token: string): Promise<MediaObject> =>
    this.http.get(this.buildUrl(this.route.mediaByToken, { token }));

  temporaryUrlsByToken = (
    token: string,
    config?: AxiosRequestConfig,
  ): Promise<MediaTemporaryUrlsResponse> =>
    this.http.get(this.buildUrl(this.route.temporaryUrlsByToken, { token }), config);
}

export { MediaLinkClient };
